"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JoinTileImage = void 0;
var _imageSizesHelper = require("@ori/image-sizes-helper");
var _jsxRuntime = require("react/jsx-runtime");
const JoinTileImage = ({
  image,
  name
}) => {
  const imagesVariants = {
    url: image,
    imageFormat: 'WebP',
    imageSizeMultiplier: 2,
    params: [{
      width: 680,
      quality: 90
    }]
  };
  const images = (0, _imageSizesHelper.getImageVariants)(imagesVariants);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
    src: image,
    alt: name,
    sizes: "452px",
    srcSet: (0, _imageSizesHelper.generateSrcSet)(images),
    loading: "lazy",
    decoding: "async"
  });
};
exports.JoinTileImage = JoinTileImage;